const config = {
  MAX_FILE_SIZE: 5000000,

};

export default config;